import { Component } from "@angular/core";
import { TranslationService } from "../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";

@Component({
  selector: "check-contribution-warning",
  template: `
    <div
      class="relative w-10 h-10 rounded-xl w-full text-sm p-4 flex flex-row items-center gap-2 mb-4"
      style="border: #3b3b3b 1px solid; background-color: #fafae1"
    >
      <img
        class="mb-1"
        alt=""
        src="../../../assets/svg/alert-triangle-red.svg"
      />

      <span> {{ (translations$ | async).noChecksForContribution }} </span>
    </div>
  `,
  styleUrls: ["./check-contribution-warning.component.scss"],
})
export class CheckContributionWarningComponent {
  public translations$: Observable<ITranslations>;
  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/check-contribution-warning/check-contribution-warning.component.ts